/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".status-label[_ngcontent-%COMP%]{text-transform:capitalize;color:#fff!important}.issue-status.mat-chip.mat-primary.mat-standard-chip[_ngcontent-%COMP%]{color:#fff;text-transform:capitalize;font-weight:700;pointer-events:none}\n/*# sourceMappingURL=issue.css.map*/"];
export { styles as styles };
